var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('a',[_c('router-link',{attrs:{"to":"/users"}},[_c('b-icon-arrow-left-circle'),_vm._v(" Voltar")],1)],1),_c('RegisterForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }